<template>
  <div class="smart-contract page-container" :class="{ 'page-container--with-sidebar': isSidebarPresent }">
    <template v-if="Object.keys(document).length > 0">
      <div class="smart-contract__heading">
        <div class="smart-contract__breadcrumbs">
          <router-link class="smart-contract__contracts-link" :to="{ name: 'smart_contracts_path' }">Vzorci</router-link>
          <div class="smart-contract__name-separator">></div>
          <div class="smart-contract__name">{{ document.name }}</div>
        </div>
        <div class="smart-contract__price" v-if="document.accountId == null && document.priceLabel">{{ document.priceLabel }}</div>
      </div>
    </template>

    <document-composition :id="id" />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import DocumentComposition from './document_composition/DocumentComposition'
import prompt from 'design-system/components/prompt/prompt.js'

export default {
  components: { DocumentComposition },
  props: {
    id: { type: [String, Number], required: true },
  },
  computed: {
    ...mapState(['isLoading']),
    ...mapGetters('pages/documentComposition', ['document', 'hasUnsavedChanges']),
    ...mapGetters(['isLoggedIn']),
  },
  methods: {
    ...mapActions('pages/documentComposition', ['initialize']),
  },
  async beforeRouteLeave (to, from, next) {
    if (!this.hasUnsavedChanges || !this.isLoggedIn) {
      next()
      return
    }

    const confirmMessage = 'Dokument še ni shranjen.\n\nČe boste zapustili to stran, bo vaš vnos izgubljen. Izberite OK, da zapustite stran in izgubite vnos ali Nazaj, da ostanete na tej strani.'
    const confirmed = await prompt.okText('OK').confirm(confirmMessage)
    if (confirmed) {
      next()
    }
  },
}
</script>

<style scoped lang='scss'>
@import 'app/assets/stylesheets/variables';
@import './common';
@import '../common';

.smart-contract {
  padding-top: 12px; // override default padding top, we need less space here
  padding-bottom: 0; // override default padding bottom, we don't need it here
}

.smart-contract__heading {
  display: flex;
  justify-content: space-between;
  padding-bottom: 24px;

  @include respond-to('small') {
    position: relative;
    top: -8px;
    padding-bottom: 8px;
  }
}

.smart-contract__price {
  min-width: 64px;
  height: fit-content;
  font-size: 14px;
  line-height: 36px;
  font-weight: 600;
  color: $primary-blue;
  flex-shrink: 0;
}

.smart-contract__breadcrumbs {
  display: flex;
  line-height: 36px;
  font-size: 14px;
  font-weight: 500;
  color: $black-text;
}

.smart-contract__contracts-link {
  text-decoration: none;
}

.smart-contract__name-separator {
  padding: 0 14px;

  @include respond-to('small') {
    padding: 0 6px;
  }
}

.smart-contract__name {
  display: flex;
  font-size: 14px;
  font-weight: 500;
  color: $disabled-gray;
}
</style>
